module.exports = __webpack_public_path__ + "static/media/AvenirNext400.17efa06c.woff";